import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/firestore";
import "firebase/compat/storage";
//import { FIREBASE_PROJECT } from "../../app_constant";

const FIREBASE_PROJECT = `${process.env.REACT_APP_FIREBASE_PROJECT}`;

const firebaseConfig_learnzapp_test = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY_LZ_TEST}`,
  authDomain: "learnzapp-test.firebaseapp.com",
  projectId: "learnzapp-test",
  storageBucket: "learnzapp-test.appspot.com",
  messagingSenderId: "583000286226",
  appId:
    "1:583000286226:web:3a9a1c8a06e325df0fa4cb1:583000286226:web:3a9a1c8a06e325df0fa4cb",
  measurementId: "G-WQH86P90XZ",
};
// Project: Learnzapp
const firebaseConfig_learnzapp_1 = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY_LZ_1}`,
  authDomain: "lsat-b6833.firebaseapp.com",
  databaseURL: "https://lsat-b6833.firebaseio.com",
  projectId: "lsat-b6833",
  storageBucket: "lsat-b6833.appspot.com",
  messagingSenderId: "553021261514",
  appId: "1:553021261514:web:86d5d36ca53e78eb941633",
  measurementId: "G-EJF2F7HYGW",
};

// Project: learnzapp-2
const firebaseConfig_learnzapp_2 = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY_LZ_2}`,
  authDomain: "learnzapp-2.firebaseapp.com",
  projectId: "learnzapp-2",
  storageBucket: "learnzapp-2.appspot.com",
  messagingSenderId: "921783555239",
  appId: "1:921783555239:web:db32c051a773618892b782",
  measurementId: "G-S4C6QWK9GY",
};
// White-label brands run on their own Firebase project (e.g. wl-trainingcamp), which is
// not one of the hardcoded LearnZapp projects above. When the brand env supplies a full
// Firebase web config (REACT_APP_FIREBASE_PROJECT_ID present), build the config straight
// from those env vars. Existing LearnZapp brands don't set it, so they keep the legacy
// REACT_APP_FIREBASE_PROJECT selection below — fully backward compatible.
const firebaseConfig_white_label = process.env.REACT_APP_FIREBASE_PROJECT_ID
  ? {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    }
  : null;

console.log("FIREBASE_PROJECT", FIREBASE_PROJECT);
const config =
  firebaseConfig_white_label
    ? firebaseConfig_white_label
    : FIREBASE_PROJECT === "learnzapp-1"
    ? firebaseConfig_learnzapp_1
    : FIREBASE_PROJECT === "learnzapp-2"
    ? firebaseConfig_learnzapp_2
    : firebaseConfig_learnzapp_test;

 console.log("config", config);
firebase.initializeApp(config);

// Debug logs to verify Firebase connection
try {
  const appInstance = firebase.app();
  console.log("✅ Firebase App initialized successfully");
  console.log("   App Name:", appInstance.name);
  console.log("   Project ID:", appInstance.options?.projectId);
  console.log("   Auth Domain:", appInstance.options?.authDomain);
  console.log("   Storage Bucket:", appInstance.options?.storageBucket);
  
  // Verify services are available
  const authInstance = firebase.auth();
  const firestoreInstance = firebase.firestore();
  const storageInstance = firebase.storage();
  const functionsInstance = firebase.functions();
  
  console.log("✅ Firebase Services initialized:");
  console.log("   Auth:", authInstance ? "✅ Available" : "❌ Not available");
  console.log("   Firestore:", firestoreInstance ? "✅ Available" : "❌ Not available");
  console.log("   Storage:", storageInstance ? "✅ Available" : "❌ Not available");
  console.log("   Functions:", functionsInstance ? "✅ Available" : "❌ Not available");
  
  // Test Firestore connection with a simple operation
  firestoreInstance.enableNetwork()
    .then(() => {
      console.log("✅ Firestore network connection: Active");
    })
    .catch((error) => {
      console.warn("⚠️ Firestore network check:", error.message);
    });
  
} catch (error) {
  console.error("❌ Firebase initialization failed:", error);
  console.error("   Error details:", error.message);
  console.error("   Stack:", error.stack);
}

const app = firebase.app;
const auth = firebase.auth;
const firestore = firebase.firestore;
const storage = firebase.storage;
const functions = firebase.functions;
export { auth, firestore, storage, functions, app };
